import { VideoPlayer } from './video-player'

export function VideoPlayerManager() {
  this.maxCount = 4
  this.players = []
  this.currentPlayer = null
  this.currentPlayerId = 0
  this.currentStreamNodeId = 0
  this.currentLayout = {name: '四画面', count: 4}
  this.streamNodes = []
  if (window && window.config) {
    this.requestRequired = window.config.sendRequestBeforePlay // 是否包含请求
  } else {
    this.requestRequired = false
  }
  // 初始化播放器数组
  for (let i = 1; i <= this.maxCount; ++i) {
    this.players[i - 1] = new VideoPlayer('video-player' + i, '窗口' + i, i - 1)
    this.streamNodes.push(null)
  }
}

// 打开多个播放器
VideoPlayerManager.prototype.openVideoPlayers = async function (streamNodes) {
  // 返回可用的视频播放器数组
  let players = []
  streamNodes.forEach((item, index) => {
    for (let i = 0; i < this.players.length; ++i) {
      if (!this.players[i].active && !players.includes(this.players[i])) {
        players.push(this.players[i])
        // 更新视频节点
        this.streamNodes[i] = streamNodes[index]
        break
      }
    }
  })

  if (players.length === 0) {
    return
  }
  // 移除多余视频节点元素
  if (streamNodes.length > players.length) {
    streamNodes = streamNodes.slice(0, players.length - 1)
  }

  // 遍历数组
  if (this.requestRequired) { // 是否包含请求
    for (let i = 0; i < streamNodes.length; ++i) {
      await players[i].startPlayWithRequest(streamNodes[i].id, streamNodes[i].name, streamNodes[i].streamOpenMode, streamNodes[i].audioEnabled,
        streamNodes[i].accessToken, streamNodes[i].playProtocol, streamNodes[i].streamServerIp, streamNodes[i].streamServerPort3) // 端口3为rtmp/hls/flv端口
    }
  } else {
    for (let i = 0; i < streamNodes.length; ++i) {
      await players[i].startPlay(streamNodes[i].id, streamNodes[i].name, streamNodes[i].streamOpenMode, streamNodes[i].audioEnabled,
        streamNodes[i].accessToken, streamNodes[i].playProtocol, streamNodes[i].streamServerIp, streamNodes[i].streamServerPort3) // 端口3为rtmp/hls/flv端口
    }
  }

  players[0].selected = true
  this.currentPlayer = players[0]
  this.currentPlayerId = players[0].id
  this.currentStreamNodeId = players[0].streamNodeId
}

// 打开一个播放器
VideoPlayerManager.prototype.openVideoPlayer = function (streamNodeId, streamNodeName, streamOpenMode, audioEnabled, accessToken, playProtocol, streamServerIp, streamServerPort) {
  let player = this.findFirstInactiveVideoPlayer()
  if (player == null) {
    return null
  }

  if (this.requestRequired) { // 是否包含请求
    player.startPlayWithRequest(streamNodeId, streamNodeName, streamOpenMode, audioEnabled, accessToken, playProtocol, streamServerIp, streamServerPort)
  } else {
    player.startPlay(streamNodeId, streamNodeName, streamOpenMode, audioEnabled, accessToken, playProtocol, streamServerIp, streamServerPort)
  }
  player.selected = true
  this.currentPlayer = player
  this.currentPlayerId = player.id
  this.currentStreamNodeId = streamNodeId
  // 更新视频节点
  this.streamNodes[this.players.indexOf(player)] = {
    id: streamNodeId,
    name: streamNodeName,
    streamOpenMode: streamOpenMode,
    audioEnabled: audioEnabled
  }

  return player
}

// 关闭一个播放器
VideoPlayerManager.prototype.closeVideoPlayer = function(streamNodeId) {
  let noSelected = false
  for (let i = 0; i < this.players.length; ++i) {
    let player = this.players[i]
    if (player.active && streamNodeId === player.streamNodeId) {
      if (this.requestRequired) { // 是否包含请求
        player.stopPlayWithRequest()
      } else {
        player.stopPlay()
      }

      noSelected = player.selected
      player.selected = false
      this.currentPlayer = null
      this.currentPlayerId = 0
      this.currentStreamNodeId = 0
      this.streamNodes[i] = null
      break
    }
  }

  if (noSelected) { // 没有被选中的播放器，则重新选中首个播放中的播放器
    let player = this.findFirstActiveVideoPlayer()
    if (player != null) {
      this.currentPlayer = player
      this.currentPlayer.selected = true
      this.currentPlayerId = this.currentPlayer.id
      this.currentStreamNodeId = this.currentPlayer.streamNodeId
    }
  }
}

// 关闭全部播放器
VideoPlayerManager.prototype.closeAll = function() {
  this.players.forEach(async (item, index) => {
    if (this.requestRequired) { // 是否包含请求
      await item.stopPlayWithRequest()
    } else {
      await item.stopPlay()
    }
    item.selected = false
  })

  this.currentPlayer = null
  this.currentPlayerId = 0
  this.currentStreamNodeId = 0
  this.streamNodes = []
}

// 选中一个播放器
VideoPlayerManager.prototype.select = function(player) {
  if (this.currentPlayer === player) {
    return
  }

  this.players.forEach((item, index) => {
    item.selected = false
  })

  if (player.active) {
    player.selected = true
    this.currentPlayer = player
    this.currentPlayerId = player.id
    this.currentStreamNodeId = player.streamNodeId
  }
}

// 选中一个播放器
VideoPlayerManager.prototype.selectByStreamNodeId = function(streamNodeId) {
  if (this.currentStreamNodeId === streamNodeId) {
    return
  }

  this.currentPlayer = null
  this.currentPlayerId = 0
  this.currentStreamNodeId = 0
  this.players.forEach((item, index) => {
    if (item.active && streamNodeId === item.streamNodeId) {
      item.selected = true
      this.currentPlayer = item
      this.currentPlayerId = item.id
      this.currentStreamNodeId = item.streamNodeId
    } else {
      item.selected = false
    }
  })
}

// 切换布局
VideoPlayerManager.prototype.switchLayout = function(layout) {
  this.currentLayout = layout
}

// 是否为单画面显示
VideoPlayerManager.prototype.isSingle = function() {
  if (this.currentLayout !== null && this.currentLayout.count === 1) {
    return true
  }

  return false
}

// 返回播放中的视频播放器数量
VideoPlayerManager.prototype.getActiveVideoPlayerCount = function() {
  let count = 0
  for (let i = 0; i < this.players.length; ++i) {
    if (this.players[i].active) {
      ++count
    }
  }

  return count
}

// 返回未播放的视频播放器数量
VideoPlayerManager.prototype.getInactiveVideoPlayerCount = function() {
  let count = 0
  for (let i = 0; i < this.players.length; ++i) {
    if (!this.players[i].active && i < this.currentLayout.count) {
      ++count
    }
  }

  return count
}

// 查找返回首个播放中的视频播放器
VideoPlayerManager.prototype.findFirstActiveVideoPlayer = function() {
  for (let i = 0; i < this.players.length; ++i) {
    if (this.players[i].active) {
      return this.players[i]
    }
  }

  return null
}

// 查找返回首个未播放的视频播放器
VideoPlayerManager.prototype.findFirstInactiveVideoPlayer = function() {
  for (let i = 0; i < this.players.length; ++i) {
    if (!this.players[i].active) {
      return this.players[i]
    }
  }

  return null
}

export { VideoPlayer }



// WEBPACK FOOTER //
// ./src/utils/video-player-manager.js